import React, { useState } from 'react'
import { DialogTitle, DialogContent, Box, Typography } from '@mui/material'
import { toast } from 'react-toastify'

import { useAjaxContext } from '../../../../core/ajax'
import { MarketerUsersForm } from '../form'
import { feedback } from '../../../../core/feedback'

export const MarketerUsersEditDialogComponent = ({ close, user, setUser, getUserData }) => {
  const { putById } = useAjaxContext()

  const [formState, setFormState] = useState(user)
  const [isLoading, setIsLoading] = useState(false)

  const handleChangeForm = (event) =>
    setFormState({ ...formState, [event.target.name]: event.target.value })

  const handleEditUser = (event) => {
    event.preventDefault()
    setIsLoading(true)
    const { empresa, empresa_id, ...userState } = formState
    putById('/instalador', formState['id'], userState)
      .then(() => {
        setIsLoading(false)
        toast.success(
          <>
            <Typography
              variant="body1"
              display="inline"
              style={{ verticalAlign: 'super', marginLeft: 8 }}
            >
              Datos guardados
            </Typography>
          </>
        )
        getUserData(user.id)

        close()
      })
      .catch(({ response }) => {
        feedback('error', response.data.message || 'No se han podido guardar los cambios')
        setIsLoading(false)
      })
  }

  return (
    <Box p={2}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="h4" color="textSecondary">
            Editar usuario
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <MarketerUsersForm
          {...{
            formState,
            close,
            onSubmit: handleEditUser,
            onChange: handleChangeForm,
            isLoading,
          }}
        />
      </DialogContent>
    </Box>
  )
}
